export * from './weak-set/from.js';
export * from './weak-set/is-weak-set.js';
export * from './weak-set/of.js';
